module.exports = "<svg viewBox=\"0 0 24 24\"><path d=\"M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2\"/><circle cx=\"12\" cy=\"7\" r=\"4\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/user.svg
// module id = kV7K
// module chunks = 0